// extracted by mini-css-extract-plugin
export var measureBox = "_ab-0";